<template>
    <div >
        <img class="Authenticity-header" src="../../static/image/security/Authenticity/Authenticity-heare.png">
        <div class="Authenticity-main">
            <el-row>
                <el-col :xs="{span: 22, offset: 1}" :sm="{span: 16, offset: 4}" :md="{span: 16, offset: 4}" :lg="{span: 12, offset: 6}" :xl="{span: 12, offset: 6}">
                    <div class="Authenticity-box">
                        <div class="Authenticity-boxs">
                            <el-input v-model="input" placeholder="请输入产品序列号或LOT号码"></el-input>
                            <el-button @click="findQA" type="primary" icon="el-icon-search" round>查询</el-button>
                        </div>
                    </div>
<!--                    <div class="Authenticity-text">-->
<!--                        查询完毕显示查询结果-->
<!--                    </div>-->
                    <div class="Authenticity-D">
                        {{pormpt}}
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
  name: "Authenticity",
  metaInfo: {
    title: '防伪查询', // set a title
    meta: [{                 // set meta
      name: 'keyWords',
      content: '防伪查询'
    }],
    link: [{                 // set link
      rel: 'description',
      content: '这是索康的官网的防伪查询'
    }]
  },
  created() {
    // 创建时执行跳转锚点位置
    this.$nextTick(() => {
      // console.log(findId)
      this.$store.dispatch('method/anchorPoint', 'header')
    })
  },
  data(){
    return{
      input:'',
      pormpt:''
    }
  },
  methods:{
    findQA(){
      // console.log(this.input)
      this.$store.dispatch('QA/QAfind',{name:this.input}).then((res) => {
        // console.log(res)
        this.pormpt='该序列号或LOT码来自于官方数据库'
      }).catch(error => {
        //
        this.pormpt='出错了，官方数据库中没有该序列号或LOT码'
      })
    }
  }
}
</script>
<style scoped>

</style>

<style>
    .Authenticity-header{
        width: 100%;
    }

    .Authenticity-main{
        background-color: #f9f9f9;
    }

    .Authenticity-box{
        margin-top: 100px;
        font-size: 20px;
        font-family: SY-Light;
        padding-bottom: 80px;
        border-bottom: 2px solid #430098;
    }

    .Authenticity-boxs{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-radius: 80px;
        background-color: white;
        padding-left: 30px;
        -moz-box-shadow: 2px 2px 10px #909090;
        -webkit-box-shadow: 2px 2px 10px #909090;
        box-shadow:2px 2px 10px #909090;
        height: 60px;
    }

    .Authenticity-boxs > .el-button.is-round{
        border-radius: 80px;
        width: 177px;
        background-color: #400099;
        border-color:#400099;
        font-size: 20px;
        font-family: SY-Light;
        height: 60px;
    }

    .Authenticity-boxs >.el-input .el-input__inner{
        border: 0px solid #DCDFE6;
        font-size: 20px;
        font-family: SY-Light;
        height: 60px;
        padding: 0;
    }

    .Authenticity-text{
        height: 167px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        font-family: SY-Light;
        color: #606060;
    }

    .Authenticity-D{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        font-family: SY-Light;
        color: #430098;
        height: 209px;
        background-color: white;
        border-radius: 20px;
        margin-bottom: 168px;
        -moz-box-shadow: 2px 2px 10px #909090;
        -webkit-box-shadow: 2px 2px 10px #909090;
        box-shadow:2px 2px 10px #909090;
        margin-top: 80px;
    }

    @media screen and (max-width: 750px) {
        .Authenticity-boxs{
            height: 140px;
            padding-left: 50px;
        }

        .Authenticity-boxs > .el-button.is-round{
            height: 140px !important;
            width: 300px !important;
            font-size: 40px;
        }

        .Authenticity-boxs >.el-input .el-input__inner{
            height: 140px !important;
            font-size: 40px;
        }

        .Authenticity-D{
            height: 600px;
            font-size: 35px;
        }
    }
</style>
